module.exports = __webpack_public_path__ + "static/media/notes-of-love-seven.ebb51695.png";